module.exports = __webpack_public_path__ + "static/media/door.9b3c0216.png";